import React from "react";
import D01 from "../Download/D01";
export default function DownlMain({ data }) {
  return (
    <div>
      {data?.advanceData?.design === 'D01_L01' ? (
        <D01 downlItem={data}></D01>
      ) : (
        <D01 downlItem={data}></D01>
      )}
    </div>
  );
}
